module.exports = ".link {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/stat/stat.component.scss
// module id = ./src/app/shared/modules/stat/stat.component.scss
// module chunks = main